import { initializeApp, getApps } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth, GoogleAuthProvider, signInAnonymously, signInWithPopup, signOut } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyA8LQ6myzvxtXs5obEruxI2wUW9a7cLFU4',
  authDomain: 'musabagh-63481.firebaseapp.com',
  databaseURL: 'https://musabagh-63481-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'musabagh-63481',
  storageBucket: 'musabagh-63481.firebasestorage.app',
  messagingSenderId: '992748673716',
  appId: '1:992748673716:web:57a1e0770ed64c69e915e1'
};

const hasFirebaseConfig = Object.values(firebaseConfig).every(Boolean);

const app = hasFirebaseConfig
  ? getApps().length
    ? getApps()[0]
    : initializeApp(firebaseConfig)
  : null;

if (app && typeof window !== 'undefined') {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Ldj7fgsAAAAAIoVSrB30nL3j2yNex7VeKQCteC-'),
    isTokenAutoRefreshEnabled: true
  });
}

export const db = app ? getDatabase(app) : null;
export const auth = app ? getAuth(app) : null;
export const isFirebaseConfigured = Boolean(app);

export const signInStatsViewer = async () => {
  if (!auth) return null;
  if (auth.currentUser?.uid) return auth.currentUser.uid;
  const result = await signInAnonymously(auth);
  return result.user.uid;
};

export const signInStatsViewerWithGoogle = async () => {
  if (!auth) return null;
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  const result = await signInWithPopup(auth, provider);
  return result.user;
};

export const signOutStatsViewer = async () => {
  if (!auth) return;
  await signOut(auth);
};
